import isNumeric from 'validator/es/lib/isNumeric';
import { removeEmpty, stringToCheck } from './resultsHelper';

const parseNumericValue = (value, defaultValue = null, fieldType = 'integer') => {
  const number = stringToCheck(value);

  if (!isNumeric(number)) {
    return defaultValue;
  }

  return (fieldType === 'integer'
    ? parseInt(stringToCheck(number), 10)
    : parseFloat(stringToCheck(number)));
};

export const numberRangeValues = (values, defaultValue = 0, fieldType = 'integer') => {
  const newValues = [parseNumericValue(values[0], defaultValue, fieldType)];
  newValues[1] = parseNumericValue(values[1], defaultValue, fieldType);

  return removeEmpty(newValues).map((v) => v.toString());
};

export const numbersValues = (values, defaultValue = 0, fieldType = 'integer') => {
  const newValues = [parseNumericValue(values[0], defaultValue, fieldType)];
  for (let i = 1; i < values.length; i++) {
    newValues.push(parseNumericValue(values[i], defaultValue, fieldType));
  }

  return removeEmpty(newValues).map((v) => v.toString());
};

export const zeroPad = (num, places) => String(num).padStart(places, '0');

export default parseNumericValue;
